import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tj-switch',
  templateUrl: './tj-switch.component.html',
  styleUrls: ['./tj-switch.component.css']
})
export class TjSwitchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  @Input() label: string;
  @Input() disabled: boolean = false;

  switchValue = false;
}
